import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { usePasskey } from '@/features/Auth/auth.hooks'
import { AppRoutes } from '@/routes'
import { authService } from '@/services'
import { trackUserAction } from '@/shared/helpers/sentry'
import { useAuthStore } from '@/store'
import { useOtpStore } from '@/store/otp/otp.store'
import { Button, Flex, message } from 'antd'
import { AxiosError } from 'axios'
import * as Sentry from '@sentry/nextjs'
import { useRouter } from 'nextjs-toploader/app'
import React, { useCallback, useEffect } from 'react'
import styles from './AuthPasskey.module.scss'

type Props = {
  onBack?: () => void;
}

export function AuthPasskeyForm({ onBack }: Props = {}) {
  const { login, isLoading, error } = usePasskey()
  const router = useRouter()
  const userId = useAuthStore((state) => state.userId)
  const setEmail = useOtpStore((state) => state.setEmail)

  const handleSignIn = useCallback(async () => {
    const loginRes = await login()
    if (loginRes && 'error' in loginRes) {
      return
    }
    router.replace(`${AppRoutes.AUTH_SIGNIN}?step=5`)
  }, [login, router])

  const handleMfa = useCallback(async () => {
    trackUserAction('User clicked Passkey not available')
    try {
      const res = await authService.pubEmailVerificaion(userId)
      setEmail(res.maskedEmail)
      router.push(`${AppRoutes.PUB_EMAIL_CODE}`)
    } catch (e) {
      Sentry.captureException(e)
      if (error instanceof AxiosError) {
        message.error(error.response.data.message)
      }
    }
  }, [error, setEmail, router, userId])

  useEffect(() => {
    if (error) {
      if (error instanceof AxiosError) {
        message.error(error.response.data.message)
      }
    }
  }, [error])

  return (
    <Flex vertical justify="center" align="center" className="mobileContainer">
      <Flex className="w-full" flex={1} gap={15} justify="center" vertical>
        <span className={styles.icon}>🔑</span>
        <AppTitle text="Sign in with Your Passkey" centered />
        <p className={styles.text}>
          For a faster and more secure way to sign in, please use your passkey. Just click the button below and follow the prompts:
        </p>
      </Flex>
      <div className="w-full">
        <Button block loading={isLoading} onClick={handleSignIn} type="primary" size="large" className={styles.button}>Sign in</Button>
        {onBack && (
          <Button block onClick={onBack} size="large" className="mobileSecondaryButton">Back</Button>
        )}
        <a
          onClick={(event) => { event.preventDefault(); handleMfa().then(() => {}) }}
          className={styles.notAvailable}
        >
          My Passkey not available
        </a>
      </div>
    </Flex>
  )
}
